import { bodyClipContext } from '@/contexts/bodyClip'
import { useContext, useEffect } from 'react'

export function useBodyClip(applyClip: boolean, reason: string) {
	const { clip, unclip } = useContext(bodyClipContext)
	useEffect(() => {
		if (applyClip) clip(reason)
		return () => unclip(reason)
	}, [applyClip, reason, clip, unclip])
}
